import { useTranslation } from 'react-i18next'
import { FormControl, MenuItem, Select, SelectChangeEvent } from '@mui/material'

import { DatePickerDropdownValue } from '../types'

interface DateRangeDropdownProps {
  value?: DatePickerDropdownValue
  dropdownOptions: DatePickerDropdownValue[]
  onChange: (value: DatePickerDropdownValue) => void
}

export const DateRangeDropdown = ({ value, dropdownOptions, onChange }: DateRangeDropdownProps) => {
  const { t } = useTranslation()

  const dateRangeOptions: { text: string; value: DatePickerDropdownValue }[] = [
    { text: t('dateRangeOptions.custom', 'Custom'), value: 'custom' },
    { text: t('dateRangeOptions.thisMonth', 'This Month'), value: 'thisMonth' },
    { text: t('dateRangeOptions.lastMonty', 'Last Month'), value: 'lastMonth' },
    { text: t('dateRangeOptions.singleDay', 'Single Day'), value: 'singleDay' },
    { text: t('dateRangeOptions.noStartDate', 'No Start Date'), value: 'noStart' },
    { text: t('dateRangeOptions.noEndDate', 'No End Date'), value: 'noEnd' },
  ]

  const filteredOptions = dateRangeOptions.filter(option => dropdownOptions.includes(option.value))

  return (
    <FormControl size="small" fullWidth>
      <Select
        value={value}
        inputProps={{ 'aria-label': t('datePicker.dateRangePreset', 'Date range preset') }}
        onChange={(event: SelectChangeEvent) =>
          onChange(event.target.value as DatePickerDropdownValue)
        }
        data-testid="date-range-dropdown"
      >
        {filteredOptions.map(option => (
          <MenuItem key={option.value} value={option.value}>
            {option.text}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
